import React, { useState } from "react";

const QUESTIONS = [
  {
    q: "What does HTML stand for?",
    options: [
      "Hyper Text Markup Language",
      "Home Tool Markup Language",
      "Hyperlinks and Text Markup Language",
    ],
    a: 0,
  },
  {
    q: "Inside which HTML element do we put the JavaScript?",
    options: ["<script>", "<js>", "<javascript>"],
    a: 0,
  },
  {
    q: "Which symbol is used for comments in JS?",
    options: ["<!--", "//", "/*"],
    a: 1,
  },
];

export default function Quiz() {
  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);

  const handleAnswer = (index) => {
    if (index === QUESTIONS[current].a) setScore(score + 1);
    if (current + 1 < QUESTIONS.length) setCurrent(current + 1);
    else setShowResult(true);
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-4">
      <div className="bg-slate-800 w-full max-w-md p-8 rounded-2xl shadow-2xl text-white">
        {showResult ? (
          <div className="text-center">
            <h2 className="text-3xl font-bold mb-4">Quiz Finished!</h2>
            <p className="text-xl mb-6">
              You scored {score} out of {QUESTIONS.length}
            </p>
            <button
              onClick={() => {
                setCurrent(0);
                setScore(0);
                setShowResult(false);
              }}
              className="px-6 py-2 bg-indigo-600 rounded-lg font-bold"
            >
              Restart Quiz
            </button>
          </div>
        ) : (
          <div>
            <p className="text-sm text-slate-400 mb-2">
              Question {current + 1} of {QUESTIONS.length}
            </p>
            <h2 className="text-2xl font-bold mb-6">{QUESTIONS[current].q}</h2>
            <div className="flex flex-col gap-3">
              {QUESTIONS[current].options.map((opt, i) => (
                <button
                  key={i}
                  onClick={() => handleAnswer(i)}
                  className="w-full text-left px-4 py-3 bg-slate-700 hover:bg-indigo-600 rounded-xl transition"
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
